module.exports = __webpack_public_path__ + "static/img/company-component-cove-5-3.1355fc18.jpg";